import Button from "@mui/material/Button";

export default function MainButton({
  text,
  onClick,
  grow = false,
  secondary = false,
  destructive = false,
  disabled = false,
}) {
  let backGroundColor = "rgb(241,93,34)";
  let hoverBackGroundColor = "rgb(211,70,13)";
  let fontColor = "rgb(255,255,255)";
  let border = "none";
  let boxShadow = "none";
  let disabledBackgroundColor = secondary ? "rgb(224,224,224)" : "rgb(229,229,229)";
  let disabledColor = secondary ? "#8a8a8a" : "#b0b0b0";

  if (secondary) {
    backGroundColor = "rgb(224,224,224)";
    hoverBackGroundColor = "rgb(210,210,210)";
    fontColor = "#666666";
    disabledBackgroundColor = "rgb(224,224,224)";
    disabledColor = "#8a8a8a";
  }

  if (destructive) {
    backGroundColor = "#ffffff";
    hoverBackGroundColor = "#fff6f3";
    fontColor = "#c53d13";
    border = "1px solid #d5d9e1";
    boxShadow = "none";
    disabledBackgroundColor = "#ffffff";
    disabledColor = "#d8a696";
  }

  return (
    <Button
      onClick={onClick}
      variant="contained"
      disabled={disabled}
      sx={{
        backgroundColor: backGroundColor,
        textTransform: "none",
        fontSize: "15px",
        color: fontColor,
        minWidth: grow ? "160px" : "auto",
        minHeight: "40px",
        px: 2,
        py: 0.75,
        borderRadius: "4px",
        boxShadow,
        border,

        "&:hover": {
          backgroundColor: hoverBackGroundColor,
          boxShadow,
        },
        "&.Mui-disabled": {
          backgroundColor: disabledBackgroundColor,
          color: disabledColor,
          border,
          boxShadow: "none",
        },
      }}
      className={grow ? "grow" : ""}
    >
      {text}
    </Button>
  );
}
